import React, { useContext } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Details from '../../DeviationViews/Details';
import TextualContent from '../../DeviationViews/TextualContent';
import DesktopLayout from '../_partials/DesktopLayout';
import StageBackground from '../../DeviationBackground/StageBackground';
import { ScreenSizeContext } from '@wix/da-hooks/pkg/useMeasureElement/ScreenSizeContext';

import s from './DesktopTierPage.scss';

export interface Props {
  deviation: PapiDeviation;
}

const DesktopTierPage: React.FC<Props> = ({ deviation }) => {
  const { width: screenSize } = useContext(ScreenSizeContext);

  return (
    <DesktopLayout
      deviation={deviation}
      stageContent={
        <>
          <ArtStage deviation={deviation} className={s['art-stage']} />

          <ActionBar deviation={deviation} />

          <div className={s['content']}>
            <TextualContent deviation={deviation} />
          </div>
        </>
      }
      metaContent={<Details className={s['content']} deviation={deviation} />}
      backgroundContent={
        <StageBackground deviation={deviation} width={Math.max(screenSize, 780)} />
      }
    />
  );
};
DesktopTierPage.displayName = 'DesktopTierPage';

export default DesktopTierPage;
